import { Select } from './';

import React from 'react';
import PropTypes from 'prop-types';

const AgeGroupSelect = ({ options, ...props }) => {
  const selectOptions = options.map(ageGroup => {
    const { ageMinimum = 'any', ageMaximum = 'any' } = ageGroup;
    const description = [
      ageMinimum,
      ' to ',
      <strong key="maximum">{ageMaximum}</strong>,
      ' years old',
    ];
    return {
      key: ageGroup.id,
      value: ageGroup.primaryKey,
      text: ageGroup.title,
      description,
    };
  });

  return <Select options={selectOptions} {...props} />;
};

AgeGroupSelect.propTypes = {
  options: PropTypes.array.isRequired,
};

export default AgeGroupSelect;



// WEBPACK FOOTER //
// ./src/components/AgeGroupSelect.js